import { EChartsOption } from "echarts-for-react";

export type BlockKeyProps = {
    key: string;
};

export type MultipleChartColumnData = {
    data: {
        [key: number]: {
            devices: {
                [key: string]: any;
            };
            sensor_type: string;
        };
    };
    chart_name: string;
    multipleChartType: "same" | "different";
};

export type MultipleChartBlockProps = {
    isEdit?: boolean;
    blockKey: BlockKeyProps;
    defaultValue?: MultipleChartColumnData;
    isSingleUpdate?: boolean;
    onDelete?: (item: BlockKeyProps) => void;
    onChange: (data: any) => void;
    onSubmitMultipleChart?: Function;
};

export type MultipleChartColumnProps = {
    isEdit?: boolean;
    data: MultipleChartColumnData;
    defaultValue?: MultipleChartColumnData;
    column: number;
    onChange: (data: any) => void;
};

export type ChartState = {
    option: EChartsOption;
    hasFetchedConfig: boolean;
    sensorConfigRes: any;
};

export type RefreshRate = {
    seconds: number | "auto";
    label?: string;
};

export type BarChartSeries = {
    type: string;
    name: string;
    data: any[];
    barWidth: number | string;
    color: string;
    stack?: string;
    id?: string;
};

export type CustomEChartParams = {
    liveData: any;
    chartState?: ChartState;
    liveTime: any;
    liveDate: any;
    sensorUnit: string;
    min?: any;
    max?: any;
    accuracy?: string | number;
    sensorType?: string;
    lastTimeRangeSelect?: any;
    chart: string;
};

export type BasicSensorChartProps = {
    panel: any;
    selectedDashboardUUID: string;
    isVisible: boolean;
    visibleRef: any;
    customEChartStyle: (chartColor: string) => any[];
    customEChartData?: (params: CustomEChartParams) => void;
    displayName: (chartState: ChartState) => string;
    onDelete: (selectedDashboardUUID: string) => void;
    zoomLevel: number;
    gatewaysConfig: any;
    allAlerts?: any;
    isFourWiredMotor?: boolean;
    isActuator?: boolean;
};

export enum ConsumptionChartBy {
    Day = "Day",
    Week = "Week",
    Month = "Month",
    Year = "Year",
}

export type ConsumptionChartData = {
    series: BarChartSeries[];

    categories: string[] | number[];

    /** Sum of values in the previous time period. {@link null} indicates no data. */
    previousTotal: number | null;

    total: number | null;

    /** Total value for the day that used extra API call*/
    dayTotal: number | null;

    /** Total value for the previous day that used extra API call*/
    previousDayTotal: number | null;
};

export type HeatmapTarget = {
    deviceId: string;
    targetId: string;
    x: number;
    y: number;
    z: number;
    intensity: number;
};
